import { LinkButton, P } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { ControlCard } from 'sections/onsite-campaigns/pages/CampaignEditor/components/ControlCard';
import styled, { useTheme } from 'styled-components';
import { InfoTooltip } from 'sections/onsite-campaigns/pages/CampaignEditor/components/InfoTooltip';
import { useCallback, useState } from 'react';
import { ScheduledDatesModal } from './ScheduledDatesModal';
import { useCampaignSettings } from '../../CampaignWorkflowTab/state/CampaignSettings/hooks/useCampaignSettings';
import { useFeatureFlags } from '../../../../../../../core/app/AppContext';

const SchedulingContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.designToken.spacing3};
`;

export interface SchedulingControlProps {
  campaignId: string;
}

export const SchedulingControl = () => {
  const { flagEnabled } = useFeatureFlags();
  const { t } = useTranslation('campaigns');
  const theme = useTheme();

  const {
    scheduling: { startDate, startTime, endDate, endTime },
  } = useCampaignSettings();

  const [isScheduledDatesModalOpen, setIsScheduledDatesModalOpen] = useState(false);
  const openScheduledDatesModal = useCallback(() => setIsScheduledDatesModalOpen(true), []);
  const closeScheduledDatesModal = useCallback(() => setIsScheduledDatesModalOpen(false), []);

  if (!flagEnabled('ld-enable-onsite-scheduling')) {
    return null;
  }

  return (
    <>
      <ControlCard>
        <SchedulingContent>
          <P variant="body1">
            {t('onsite.editor.workflow.scheduling.description')}
            <span style={{ marginRight: theme.designToken.spacing1 }} />
            <InfoTooltip displayInline content={t('onsite.editor.workflow.scheduling.descriptionTooltip')} />
          </P>
          <div style={{ display: 'flex', gap: theme.designToken.spacing2, flexDirection: 'column' }}>
            <div style={{ display: 'flex', gap: theme.designToken.spacing1, flexDirection: 'column' }}>
              <P style={{ padding: 0, margin: 0 }} variant="body2">
                <strong>Starts: </strong>
                {startDate ? (
                  startTime ? (
                    <>
                      {startDate.toLocaleDateString()} <strong>at</strong> {startTime} UTC
                    </>
                  ) : (
                    startDate.toLocaleDateString()
                  )
                ) : (
                  t('onsite.editor.workflow.scheduling.startDatePlaceholder')
                )}{' '}
              </P>

              <P style={{ padding: 0, margin: 0 }} variant="body2">
                <strong>Ends:</strong>{' '}
                {endDate ? (
                  <>
                    {endDate?.toLocaleDateString()}{' '}
                    {endTime ? (
                      <>
                        <strong>at</strong> {endTime} UTC
                      </>
                    ) : null}
                  </>
                ) : (
                  t('onsite.editor.workflow.scheduling.endDatePlaceholder')
                )}
              </P>
            </div>
            <LinkButton
              leftSideIcon="pen"
              onClick={openScheduledDatesModal}
              ariaLabel={t('onsite.editor.workflow.scheduling.changeDatesAria')}
            >
              {t('onsite.editor.workflow.scheduling.changeDates')}
            </LinkButton>
          </div>
        </SchedulingContent>
      </ControlCard>

      <ScheduledDatesModal open={isScheduledDatesModalOpen} onClose={closeScheduledDatesModal} />
    </>
  );
};
